import { render, staticRenderFns } from "./WeaponTable.vue?vue&type=template&id=0bb9b3af&"
import script from "./WeaponTable.vue?vue&type=script&lang=js&"
export * from "./WeaponTable.vue?vue&type=script&lang=js&"
import style0 from "./WeaponTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports